import { cn } from '@/lib/utils';

type CardBodyProps = React.ComponentProps<'div'>;

export const CardBody = ({ className, ...props }: CardBodyProps) => (
  <div
    data-slot="card-body"
    className={cn('tw-text-muted-foreground tw-text-sm', className)}
    {...props}
  />
);
